import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Helpers
import { toHours, handleSwitchInputKeys } from '../../helpers/helpers.js';

// Dependencies
import DatePicker from 'react-datepicker';
import moment from 'moment';
// import Textarea from 'react-textarea-autosize';

// Components
import TimeSelect from '../Modules/TimeSelect';
import FileUpload from '../Modules/FileUpload';
import { FeatureFlag } from 'react-launch-darkly';

const EditExamDetails = observer(class EditExamDetails extends React.Component {
  constructor() {
    super();
    this.handleDateChange = this.handleDateChange.bind(this);
    this.toggleScheduleWindow = this.toggleScheduleWindow.bind(this);
    this.handleDuration = this.handleDuration.bind(this);
  }

  componentWillMount() {
    const { exam, customConfiguration } = this.props;
    const { ExamStore } = this.props.store;

    if(typeof exam !== 'undefined' && exam.sid && !customConfiguration) {
      // Editing an exam or default configuration
      this.state = {
        startDate: moment(exam.configuration.examOpenDate),
        endDate: moment(exam.configuration.examCloseDate),
        scheduleStartDate: moment(exam.configuration.scheduleOpenDate),
        scheduleEndDate: moment(exam.configuration.scheduleCloseDate),
        isLimitedScope: exam.isLimitedScope,
        configuration: exam.configuration
      }
    } else if(customConfiguration) {
      // Editing a custom configuration
      this.state = {
        startDate: moment(customConfiguration.examOpenDate),
        endDate: moment(customConfiguration.examCloseDate),
        scheduleStartDate: moment(customConfiguration.scheduleOpenDate),
        scheduleEndDate: moment(customConfiguration.scheduleCloseDate),
        isLimitedScope: exam.isLimitedScope,
        configuration: customConfiguration
      }
    } else if(ExamStore.exam.configuration.examOpenDate) {
      this.state = {
        startDate: moment(ExamStore.exam.configuration.examOpenDate),
        endDate: moment(ExamStore.exam.configuration.examCloseDate),
        scheduleStartDate:
          moment(ExamStore.exam.configuration.scheduleOpenDate) ||
          moment('1-1-2000 00:00', 'M-D-YYYY HH:mm Z').toISOString(),
        scheduleEndDate:
          moment(ExamStore.exam.configuration.scheduleCloseDate) ||
          moment('1-1-2070 00:00', 'M-D-YYYY HH:mm Z').toISOString(),
          isLimitedScope: exam.isLimitedScope,
        configuration: exam.configuration
      }
    } else {
      this.state = {
        startDate: null,
        endDate: null,
        scheduleStartDate: null,
        scheduleEndDate: null,
        isLimitedScope: exam.isLimitedScope,
        configuration: exam.configuration
      }
    }
  }

  componentDidMount() {
    const _this = this;
    const { importedLmsExam } = this.props.store.ExamStore;

    this.duration.addEventListener('durationInput', function(e){
      _this.props.handleInput('duration', e, true);
    });

    if(importedLmsExam.examOpenDate) {
      this.setState({
        startDate: moment(importedLmsExam.examOpenDate),
      });
    }

    if(importedLmsExam.examCloseDate) {
      this.setState({
        endDate: moment(importedLmsExam.examCloseDate),
      });
    }

    if(this.state.configuration.attachments && this.state.configuration.attachments.length > 0) {
      this.setState({
        attachments: true
      });
    }
  }

  handleDateChange(date, name, e) {
    this.setState({
      [name]: date
    });

    if(name === 'startDate') {
      this.props.handleInput('examOpenDate', e, true, date, this.state.startTime);
    } else if(name === 'endDate') {
      this.props.handleInput('examCloseDate', e, true, date, this.state.endTime);
    } else if(name === 'scheduleStartDate') {
      this.props.handleInput('scheduleOpenDate', e, true, date, this.state.scheduleStartTime);
    } else {
      this.props.handleInput('scheduleCloseDate', e, true, date, this.state.scheduleEndTime);
    }
  }

  handleTimeChange(name, e) {
    let date = this.state.startDate;
    let stateName = 'startTime';

    if(name === 'examCloseDate') {
      date = this.state.endDate;
      stateName = 'endTime';
    } else if(name === 'scheduleOpenDate') {
      date = this.state.scheduleStartDate;
      stateName = 'scheduleStartTime';
    } else if(name === 'scheduleCloseDate') {
      date = this.state.scheduleEndDate;
      stateName = 'scheduleEndTime';
    }

    this.setState({
      [stateName]: e.target.value
    });

    this.props.handleInput(name, e, true, date, e.target.value);
  }

  isDisabled(fieldName) {
    // If this is an exception or it’s completely readonly
    if(this.props.exception || this.props.readonly) {
      return true;
    }

    // Otherwise, if this field was provided in a list of disabled fields
    if(this.props.disabledFields && this.props.disabledFields.indexOf(fieldName) > -1) {
      return true;
    }

    return false;
  }

  enableScheduleWindow() {
    const schedulingOpens = moment.utc(this.state.scheduleStartDate).format('M-D-YYYY');
    const schedulingCloses = moment.utc(this.state.scheduleEndDate).format('M-D-YYYY');

    if((schedulingOpens === '1-1-2000' && schedulingCloses === '1-1-2070') || (this.state.scheduleStartDate === null && this.state.scheduleEndDate === null)) {
      return false;
    }

    return true;
  }

  toggleScheduleWindow(e) {
    const _this = this;
    const { ExamStore } = this.props.store;
    const { exam } = this.props;
    let scheduleStartTime = null;
    let scheduleEndTime = null;

    if(!e.target.checked) {
      // If disabling the scheduling window, set an open and close date way in the past and future
      this.setState({
        scheduleStartDate: moment('1-1-2000 00:00', 'M-D-YYYY HH:mm Z').toISOString(),
        scheduleEndDate: moment('1-1-2070 00:00', 'M-D-YYYY HH:mm Z').toISOString()
      });

      // Also set the time to midnight
      scheduleStartTime = '00:00';
      scheduleEndTime = '00:00';

      // Make sure stored exam is updated
      if(exam) {
        setTimeout(function(){
          ExamStore.exam.configuration.scheduleOpenDate = _this.state.scheduleStartDate;
          ExamStore.exam.configuration.scheduleCloseDate = _this.state.scheduleEndDate;
        });
      }
    } else {
      // Otherwise, default to the exam open and close dates
      this.setState({
        scheduleStartDate: this.state.startDate ? moment(this.state.startDate).subtract(1, 'minute') : '',
        scheduleEndDate: this.state.endDate || ''
      });

      // Also set the time
      setTimeout(function(){
        if(_this.scheduleStartTime) {
          scheduleStartTime = _this.scheduleStartTime.value;
          scheduleEndTime = _this.scheduleEndTime.value;
        }
      })

      // Make sure stored exam is updated
      if(exam) {
        setTimeout(function(){
          ExamStore.exam.configuration.scheduleOpenDate = _this.state.scheduleStartDate;
          ExamStore.exam.configuration.scheduleCloseDate = _this.state.scheduleEndDate;
        });
      }
    }

    setTimeout(function(){
      _this.props.handleInput('scheduleOpenDate', null, true, _this.state.scheduleStartDate, scheduleStartTime, false, null, true);
      _this.props.handleInput('scheduleCloseDate', null, true, _this.state.scheduleEndDate, scheduleEndTime, false, null, true);
    });
  }

  handleDuration() {
    const hr = parseInt(this.durationHr.value, 10);

    // This stops instructors from adding extra minutes after 8 hours
    if (hr === 8) {
      this.durationMin.value = 0;
    }

    const min = parseInt(this.durationMin.value, 10);
    const value = (hr * 60) + min;

    this.duration.value = value;

    let event = null;

    try {
      event = new Event('durationInput');
    } catch(e) {
      event = document.createEvent('Event');
      event.initEvent('durationInput', true, true)
    }

    this.duration.dispatchEvent(event);
  }

  convertDuration(unit) {
    const { importedLmsExam } = this.props.store.ExamStore;

    if(importedLmsExam.title) {
      if(unit === 'hr') {
        return Math.floor(importedLmsExam.duration / 60);
      } else {
        return importedLmsExam.duration % 60;
      }
    } else {
      if(unit === 'hr') {
        return Math.floor(this.state.configuration.duration / 60);
      } else {
        return this.state.configuration.duration % 60;
      }
    }
  }

  validateUrl(e, name) {
    // const { translation } = this.props;

    let url = e.target.value;

    if(!url.match(/^https?:\/\//)) {
      e.target.value = 'http://' + url;
    }

    this.props.handleInput('url', e);

    // if(validUrl.isUri(e.target.value)) {
    //   e.target.setCustomValidity('');
    //   this.props.handleInput('url', e);
    // } else {
    //   e.target.setCustomValidity('invalid');
    //   this.props.store.SessionStore.showDialog(translation.invalid_url);
    // }
  }

  render() {
    const { automatedOnly, exam, translation, scheduled } = this.props;
    const { ExamStore, SessionStore, SettingsStore } = this.props.store;
    const { importedLmsExam } = ExamStore;
    const { userTimezone } = SessionStore;

    return(
      <fieldset id="exam-details">
        <ul className="fields">
          {!exam.sid && SettingsStore.settings.enableWrittenExams &&
            <li>
              <label className="select">
                <select
                  defaultValue={exam.type}
                  onChange={(e) => ExamStore.exam.type = e.target.value}
                >
                  <option value="Online">{translation.exam_type.online}</option>
                  <option value="Written">{translation.exam_type.written}</option>
                </select>
              </label>
            </li>
          }
          <li>
            <label className="lbl-required" htmlFor="exam-name">{translation.exam_name.label}</label>
            <input
              type="text"
              id="exam-name"
              placeholder={translation.exam_name.helper}
              defaultValue={importedLmsExam.title || exam.title}
              onChange={(e) => {this.props.handleInput('title', e)}}
              disabled={this.isDisabled('title')}
              required
              aria-required="true"
              autoFocus />
          </li>
          {/* This description has never been used for anything. Until we have a reason for it, hide it. */}
          {/* <li>
            <label className="lbl-optional" htmlFor="exam-description">{translation.description.label}</label>

            <Textarea
              id="exam-description"
              className="textarea-grow"
              placeholder={translation.description.helper}
              defaultValue={importedLmsExam.description || exam.description}
              ref={(input) => {this.description = input}}
              onChange={(e) => {this.props.handleInput('description', e)}}
              disabled={this.isDisabled('description')}
            ></Textarea>
          </li> */}

          <FeatureFlag
            flagKey="create-limited-scope-exam"
            renderFeatureCallback={() => {
              return (
                <li>
                  <label htmlFor="limited-scope" aria-describedby="window-tooltip">
                    {translation.limited_scope.label}

                    <div className="tooltip">
                      <span className="tooltip__label" role="presentation" aria-hidden="true">(?)</span>
                      <div id="window-tooltip" className="tooltip__body" role="tooltip">{Object.keys(importedLmsExam).length !== 0 ? translation.limited_scope.imported_tooltip :translation.limited_scope.tooltip}</div>
                    </div>
                  </label>

                  <input
                    type="checkbox"
                    id="limited-scope"
                    className="switch-input"
                    defaultChecked={this.state.isLimitedScope}
                    onChange={(e) => {this.props.handleInput('isLimitedScope', e, false, false, false, true)}}
                    disabled={Object.keys(importedLmsExam).length !== 0 || this.isDisabled('isLimitedScope')}
                    onKeyDown={handleSwitchInputKeys}
                  />

                  <label className="switch-label" htmlFor="limited-scope" ><span className="meta">{ translation.limited_scope.label}</span></label>
                </li>
              )
            }}
            renderDefaultCallback={() => {
              return null
            }}
          />

          <li className={`field--auto ${this.props.defaultDiff('duration')} time-select`}>
            <label className="lbl-required" htmlFor="exam-duration-hr">{translation.duration.label}</label>

            <input
              className="inp-hidden"
              type="number"
              min="1"
              ref={(input) => {this.duration = input}}
              defaultValue={importedLmsExam.duration || this.state.configuration.duration}
              onInput={(e) => {this.props.handleInput('duration', e, true)}}
              required
              aria-required="true"
            />

            <label className="select">
              <select
                id="exam-duration-hr"
                required
                aria-required="true"
                defaultValue={this.convertDuration('hr')}
                onChange={this.handleDuration}
                ref={(input) => {this.durationHr = input}}
                disabled={
                  this.props.readonly ||
                  this.props.scheduled ||
                  (
                    this.props.disabledFields &&
                    this.props.disabledFields.indexOf('duration') > -1
                  )
                }
              >
                <option value="0">0</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
              </select>
            </label>

            <label htmlFor="exam-duration-hr" className="preposition">
              {translation.duration.hours}
            </label>

            <label className="select">
              <select
                id="exam-duration-min"
                required
                aria-required="true"
                defaultValue={this.convertDuration('min')}
                onChange={this.handleDuration}
                ref={(input) => {this.durationMin = input}}
                disabled={
                  this.props.readonly ||
                  this.props.scheduled ||
                  (
                    this.props.disabledFields &&
                    this.props.disabledFields.indexOf('duration') > -1
                  ) ||
                  (
                  this.durationHr &&
                  this.durationHr ? this.durationHr.value === '8' : false
                  )
                }
              >
                <option value="0">00</option>
                <option value="1">01</option>
                <option value="2">02</option>
                <option value="3">03</option>
                <option value="4">04</option>
                <option value="5">05</option>
                <option value="6">06</option>
                <option value="7">07</option>
                <option value="8">08</option>
                <option value="9">09</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
                <option value="13">13</option>
                <option value="14">14</option>
                <option value="15">15</option>
                <option value="16">16</option>
                <option value="17">17</option>
                <option value="18">18</option>
                <option value="19">19</option>
                <option value="20">20</option>
                <option value="21">21</option>
                <option value="22">22</option>
                <option value="23">23</option>
                <option value="24">24</option>
                <option value="25">25</option>
                <option value="26">26</option>
                <option value="27">27</option>
                <option value="28">28</option>
                <option value="29">29</option>
                <option value="30">30</option>
                <option value="31">31</option>
                <option value="32">32</option>
                <option value="33">33</option>
                <option value="34">34</option>
                <option value="35">35</option>
                <option value="36">36</option>
                <option value="37">37</option>
                <option value="38">38</option>
                <option value="39">39</option>
                <option value="40">40</option>
                <option value="41">41</option>
                <option value="42">42</option>
                <option value="43">43</option>
                <option value="44">44</option>
                <option value="45">45</option>
                <option value="46">46</option>
                <option value="47">47</option>
                <option value="48">48</option>
                <option value="49">49</option>
                <option value="50">50</option>
                <option value="51">51</option>
                <option value="52">52</option>
                <option value="53">53</option>
                <option value="54">54</option>
                <option value="55">55</option>
                <option value="56">56</option>
                <option value="57">57</option>
                <option value="58">58</option>
                <option value="59">59</option>
              </select>
            </label>

            <label htmlFor="exam-duration-min" className="preposition">
              {translation.duration.minutes}
            </label>

            {this.props.renderDefault('configuration.duration', toHours)}
            {scheduled &&
              <p className='note note--full note--full-alt'>{translation.duration.disabled}</p>
            }
          </li>

          {exam.type.toLowerCase() !== 'written' &&
            <li className={this.props.defaultDiff('password')}>
              <label
                className="lbl-required"
                htmlFor="exam-password"
                aria-describedby="password-tooltip"
              >
                {translation.password.label}

                <div className="tooltip">
                  <span
                    className="tooltip__label"
                    role="presentation"
                    aria-hidden="true"
                  >(?)</span>

                  <div
                    id="password-tooltip"
                    className="tooltip__body"
                    role="tooltip"
                  >
                    {translation.password.tooltip}
                  </div>
                </div>
              </label>

              <input
                type="text"
                id="exam-password"
                placeholder={translation.password.helper}
                required
                aria-required="true"
                defaultValue={importedLmsExam.password || this.state.configuration.password}
                onChange={(e) => {this.props.handleInput('password', e, true)}}
                disabled={
                  this.props.readonly ||
                  (
                    this.props.disabledFields &&
                    this.props.disabledFields.indexOf('password') > -1
                  )
                }
              />

              {translation.password.notice &&
                <p className='note note--full note--full-alt'>
                  {translation.password.notice}
                </p>
              }

              {this.props.renderDefault('configuration.password')}
            </li>
          }

          {exam.type.toLowerCase() !== 'written' &&
            <li>
              <label
                className="lbl-required"
                htmlFor="exam-url"
                aria-describedby="url-tooltip"
              >
                {translation.url.label}

                <div className="tooltip">
                  <span
                    className="tooltip__label"
                    role="presentation"
                    aria-hidden="true"
                  >(?)</span>

                  <div
                    id="url-tooltip"
                    className="tooltip__body"
                    role="tooltip"
                  >
                    {translation.url.tooltip}
                  </div>
                </div>
              </label>

              <input
                type="url"
                id="exam-url"
                placeholder={translation.url.helper}
                defaultValue={importedLmsExam.examUrl || exam.url}
                onChange={this.props.handleInput.bind(this, 'url')}
                onBlur={(e) => {this.validateUrl(e, 'url')}}
                required
                aria-required="true"
                disabled={this.isDisabled('url')}
              />
            </li>
          }

          <li className={`field--auto ${this.props.defaultDiff('attempts')}`}>
            <label
              className="lbl-required"
              htmlFor="exam-attempts"
              aria-describedby="attempts-tooltip"
            >
              {translation.attempts.label}

              <div className="tooltip">
                <span
                  className="tooltip__label"
                  role="presentation"
                  aria-hidden="true"
                >(?)</span>

                <div
                  id="attempts-tooltip"
                  className="tooltip__body"
                  role="tooltip"
                >
                  {translation.attempts.tooltip}
                </div>
              </div>
            </label>
            <label className="select">
              <select
                id="exam-attempts"
                required
                aria-required="true"
                defaultValue={importedLmsExam.attemptsAllowed || this.state.configuration.attempts}
                onChange={(e) => {this.props.handleInput('attempts', e, true)}}
                disabled={
                  this.props.readonly ||
                  (
                    this.props.disabledFields &&
                    this.props.disabledFields.indexOf('attempts') > -1
                  )
                }
              >
                <option>1</option>
                <option>2</option>
                <option>3</option>
                <option>4</option>
                <option>5</option>
                <option>6</option>
                <option>7</option>
                <option>8</option>
                <option>9</option>
                <option>10</option>
                <option>11</option>
                <option>12</option>
                <option>13</option>
                <option>14</option>
                <option>15</option>
                <option>16</option>
                <option>17</option>
                <option>18</option>
                <option>19</option>
                <option>20</option>
                <option>21</option>
                <option>22</option>
                <option>23</option>
                <option>24</option>
                <option>25</option>

                {/* If an imported exam allows more than 25 attempts
                the imported attempts will still be used */}
                {importedLmsExam.attemptsAllowed &&
                <option>{importedLmsExam.attemptsAllowed}</option>
                }
              </select>
            </label>

            {this.props.renderDefault('configuration.attempts')}
          </li>
        </ul>

        <h4 className="form-heading">{translation.date_settings.header}</h4>
          {scheduled &&
            <p className='note note--full'>{translation.date_settings.disabled}</p>
          }

        <ul className="fields">
          <li className={`field--auto ${this.props.defaultDiff('examOpenDate')}`}>
            <label className="lbl-required" htmlFor="exam-start-date">{translation.starts.label}</label>

            <DatePicker
              id="exam-start-date"
              selected={this.state.startDate ? moment(this.state.startDate).tz(userTimezone) : null}
              maxDate={this.state.endDate}
              onChange={(date, e) => {this.handleDateChange(date, 'startDate', e)}}
              placeholderText={translation.starts.helper}
              required aria-required="true"
              disabled={
                this.props.readonly ||
                this.props.scheduled ||
                (
                  this.props.disabledFields &&
                  this.props.disabledFields.indexOf('examOpenDate') > -1
                )
              }
              autoComplete="off"
            />

            <label className="preposition" htmlFor="exam-start-time">
              {translation.starts.at}
            </label>

            <TimeSelect
              id="exam-start-time"
              defaultValue={this.state.startDate}
              reference={(input) => {this.startTime = input}}
              onChange={(e) => {this.handleTimeChange('examOpenDate', e)}}
              date={this.state.startDate}
              name="examOpenDate"
              stateName="startTime"
              {...this.props}
              parent={this}
              disabled={
                this.props.readonly ||
                this.props.scheduled ||
                (
                  this.props.disabledFields &&
                  this.props.disabledFields.indexOf('examOpenDate') > -1
                )
              }
            />

            <span className="preposition">
              {/* If a date is selected, use that date’s dst */}
              {this.state.startDate &&
                moment.utc(this.state.startDate).tz(userTimezone).format('z')
              }

              {/* Otherwise use the current date’s dst */}
              {!this.state.startDate &&
                moment().tz(userTimezone).format('z')
              }
            </span>

            {this.props.renderDefault('configuration.examOpenDate', this.props.momentFormat)}
          </li>
          <li className={`field--auto ${this.props.defaultDiff('examCloseDate')}`}>
            <label className="lbl-required" htmlFor="exam-end-date">{translation.ends.label}</label>

            <DatePicker
              id="exam-end-date"
              selected={this.state.endDate ? moment(this.state.endDate).tz(userTimezone) : null}
              minDate={this.state.startDate}
              onChange={(date, e) => {this.handleDateChange(date, 'endDate', e)}}
              placeholderText={translation.ends.helper}
              required aria-required="true"
              disabled={
                this.props.readonly ||
                this.props.scheduled ||
                (
                  this.props.disabledFields &&
                  this.props.disabledFields.indexOf('examCloseDate') > -1
                )
              }
              autoComplete="off"
            />

            <label className="preposition" htmlFor="exam-end-time">
              {translation.ends.at}
            </label>

            <TimeSelect
              id="exam-end-time"
              defaultValue={this.state.endDate}
              reference={(input) => {this.endTime = input}}
              onChange={(e) => {this.handleTimeChange('examCloseDate', e)}}
              date={this.state.endDate}
              name="examCloseDate"
              stateName="endTime"
              {...this.props}
              parent={this}
              disabled={
                this.props.readonly ||
                this.props.scheduled ||
                (
                  this.props.disabledFields &&
                  this.props.disabledFields.indexOf('examCloseDate') > -1
                )
              }
            />

            <span className="preposition">
              {/* If a date is selected, use that date’s dst */}
              {this.state.endDate &&
                moment.utc(this.state.endDate).tz(userTimezone).format('z')
              }

              {/* Otherwise use the current date’s dst */}
              {!this.state.endDate &&
                moment().tz(userTimezone).format('z')
              }
            </span>

            {this.props.renderDefault('configuration.examCloseDate', this.props.momentFormat)}
          </li>

          {!automatedOnly &&
            <li>
              <label htmlFor="exam-window" aria-describedby="window-tooltip">
                {translation.scheduling_window.label}

                <div className="tooltip">
                  <span className="tooltip__label" role="presentation" aria-hidden="true">(?)</span>
                  <div id="window-tooltip" className="tooltip__body" role="tooltip">{translation.scheduling_window.tooltip}</div>
                </div>
              </label>

              <input
                type="checkbox"
                id="exam-window"
                className="switch-input"
                defaultChecked={this.enableScheduleWindow()}
                onChange={(e) => {this.toggleScheduleWindow(e)}}
                disabled={this.props.readonly || this.props.scheduled}
                onKeyDown={handleSwitchInputKeys}
              />

              <label className="switch-label" htmlFor="exam-window"><span className="meta">{translation.scheduling_window.label}</span></label>
            </li>
          }

          {!automatedOnly && this.enableScheduleWindow() &&
            <li className={`field--auto ${this.props.defaultDiff('scheduleOpenDate')}`}>
              <label className="lbl-required" htmlFor="schedule-start-date">{translation.scheduling_starts.label}</label>

              <DatePicker
                id="schedule-start-date"
                selected={this.state.scheduleStartDate ? moment(this.state.scheduleStartDate).tz(userTimezone) : null}
                maxDate={this.state.startDate}
                onChange={(date, e) => {this.handleDateChange(date, 'scheduleStartDate', e)}}
                placeholderText={translation.scheduling_starts.helper}
                required
                aria-required="true"
                disabled={this.props.readonly || this.props.scheduled}
                autoComplete="off"
              />

              <label className="preposition" htmlFor="schedule-start-time">
                {translation.starts.at}
              </label>

              <TimeSelect
                id="schedule-start-time"
                defaultValue={this.state.scheduleStartDate}
                reference={(input) => {this.scheduleStartTime = input}}
                onChange={(e) => {this.handleTimeChange('scheduleOpenDate', e)}}
                date={this.state.scheduleStartDate}
                name="scheduleOpenDate"
                stateName="scheduleStartTime"
                {...this.props}
                parent={this}
                disabled={this.props.readonly || this.props.scheduled}
              />

              <span className="preposition">
                {/* If a date is selected, use that date’s dst */}
                {this.state.scheduleStartDate &&
                  moment.utc(this.state.scheduleStartDate).tz(userTimezone).format('z')
                }

                {/* Otherwise use the current date’s dst */}
                {!this.state.scheduleStartDate &&
                  moment().tz(userTimezone).format('z')
                }
              </span>

              {this.props.renderDefault('configuration.scheduleOpenDate', this.props.momentFormat)}
            </li>
          }

          {!automatedOnly && this.enableScheduleWindow() &&
            <li className={`field--auto ${this.props.defaultDiff('scheduleCloseDate')}`}>
              <label className="lbl-required" htmlFor="schedule-end-date">{translation.scheduling_ends.label}</label>

              <DatePicker
                id="schedule-end-date"
                selected={this.state.scheduleEndDate ? moment(this.state.scheduleEndDate).tz(userTimezone) : null}
                maxDate={this.state.endDate}
                onChange={(date, e) => {this.handleDateChange(date, 'scheduleEndDate', e)}}
                placeholderText={translation.scheduling_ends.helper}
                required
                aria-required="true"
                disabled={this.props.readonly || this.props.scheduled}
                autoComplete="off"
              />

              <label className="preposition" htmlFor="schedule-end-time">
                {translation.starts.at}
              </label>

              <TimeSelect
                id="schedule-end-time"
                defaultValue={this.state.scheduleEndDate}
                reference={(input) => {this.scheduleEndTime = input}}
                onChange={(e) => {this.handleTimeChange('scheduleCloseDate', e)}}
                date={this.state.scheduleEndDate}
                name="scheduleCloseDate"
                stateName="scheduleEndTime"
                {...this.props}
                parent={this}
                disabled={this.props.readonly || this.props.scheduled}
              />

              <span className="preposition">
                {/* If a date is selected, use that date’s dst */}
                {this.state.scheduleEndDate &&
                  moment.utc(this.state.scheduleEndDate).tz(userTimezone).format('z')
                }

                {/* Otherwise use the current date’s dst */}
                {!this.state.scheduleEndDate &&
                  moment().tz(userTimezone).format('z')
                }
              </span>

              {this.props.renderDefault('configuration.scheduleCloseDate', this.props.momentFormat)}
            </li>
          }
        </ul>

        {exam.type.toLowerCase() !== 'written' &&
          <div>
            <h4 className="form-heading">Attachments</h4>

            <ul className="fields">
              <li>
                <FileUpload
                  {...this.props}
                  fileType={'application/pdf'}
                  label={translation.attachments.label}
                  helper={translation.attachments.helper}
                  files={this.state.configuration.attachments}
                  onDrop={(attachments) => ExamStore.examAttachments = attachments}
                  onCancel={() => this.setState({attachments: false})}
                />
              </li>
            </ul>
          </div>
        }

        {exam.type.toLowerCase() === 'written' &&
          <div>
            <h4 className="form-heading">Exam File</h4>

            <ul className="fields">
              <li>
                <FileUpload
                  {...this.props}
                  label={translation.exam_file.label}
                  helper={translation.exam_file.helper}
                  files={this.state.configuration.examFiles}
                  onDrop={(attachments) => ExamStore.examFiles = attachments}
                  single={true}
                  fileType={'application/pdf'}
                  onCancel={() => this.setState({attachments: false})}
                />
              </li>
            </ul>
          </div>
        }
      </fieldset>
    );
  }
})

export default translate('EditExamDetails')(EditExamDetails);



// WEBPACK FOOTER //
// ./src/app/components/ExamEdit/EditExamDetails.js